import type { InjectionKey } from "vue";

export const vcDialogKey: InjectionKey<VcDialogContextType> = Symbol("vc-dialog-context");
